import { SuggestionItemType } from '@moonpig/web-core-nav'
import { MAX_SUGGESTIONS } from '@moonpig/web-core-nav/src/Search/constants'
import { SearchSuggestion } from './suggestions/Suggestions'

type Props = {
  suggestion: SuggestionItemType
  items: SearchSuggestion[]
}
export const calculateSuggestionMetrics = ({
  suggestion,
  items,
}: Props): {
  position: number
  count: number
} => {
  const isAllDepartments =
    suggestion.department?.activeDepartment?.name === 'all'

  const position = isAllDepartments
    ? items.findIndex(x => x.searchKey === suggestion.searchKey) + 1
    : items
        .filter(
          item =>
            item.department.enum ===
            suggestion?.department?.activeDepartment?.enum,
        )
        .findIndex(x => x.searchKey === suggestion.searchKey) + 1

  const count = isAllDepartments
    ? Math.min(items.length, MAX_SUGGESTIONS)
    : suggestion.department?.numberOfItems || MAX_SUGGESTIONS

  return { position, count }
}
